"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverCarouselFooter: function() {
        return _TeachingPopoverCarouselFooter.TeachingPopoverCarouselFooter;
    },
    renderTeachingPopoverCarouselFooter_unstable: function() {
        return _renderTeachingPopoverCarouselFooter.renderTeachingPopoverCarouselFooter_unstable;
    },
    teachingPopoverCarouselFooterClassNames: function() {
        return _useTeachingPopoverCarouselFooterStylesstyles.teachingPopoverCarouselFooterClassNames;
    },
    useTeachingPopoverCarouselFooterStyles_unstable: function() {
        return _useTeachingPopoverCarouselFooterStylesstyles.useTeachingPopoverCarouselFooterStyles_unstable;
    },
    useTeachingPopoverCarouselFooter_unstable: function() {
        return _useTeachingPopoverCarouselFooter.useTeachingPopoverCarouselFooter_unstable;
    }
});
const _TeachingPopoverCarouselFooter = require("./TeachingPopoverCarouselFooter");
const _renderTeachingPopoverCarouselFooter = require("./renderTeachingPopoverCarouselFooter");
const _useTeachingPopoverCarouselFooter = require("./useTeachingPopoverCarouselFooter");
const _useTeachingPopoverCarouselFooterStylesstyles = require("./useTeachingPopoverCarouselFooterStyles.styles");
